<script>
export default {
  props: {
    title: {
      default: undefined,
      type: String,
    },
    imgSrc: {
      default: undefined,
      type: String,
    },
    headingTag: {
      default: 'h4',
      type: String,
    },
    location: {
      default: undefined,
      type: String,
    },
    contact: {
      default: undefined,
      type: String,
    },
    institution: {
      default: undefined,
      type: String,
    },
    position: {
      default: undefined,
      type: String,
    },
    website: {
      default: undefined,
      type: String,
    },
    newTab: {
      default: false,
      type: Boolean,
    },
  },
}
</script>

<template>
  <div class="card" :class="$style.card">
    <div class="card-body" :class="[$style.cardContent]">
      <div :class="[imgSrc ? $style.hasImage : '']">
        <img v-if="imgSrc" v-lazy="imgSrc" class="mr-3" alt="card-thumbnail" />
        <component :is="headingTag">{{ title }}</component>
      </div>

      <div :class="$style.cardInfo">
        <div v-if="location" :class="$style.infoContent" data-info="location">
          <img src="@assets/icons/Icon_D_1.png" alt="" :class="$style.icon" />
          <p>{{ location }}</p>
        </div>
        <div v-if="website" :class="$style.infoContent" data-info="website">
          <img
            v-lazy="require('@assets/icons/Icon_D_2.png')"
            alt=""
            :class="[$style.icon, $style.iconWebsite]"
          />
          <a :href="website" :target="newTab ? '_blank' : ''">{{ website }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.card {
  padding: 0.5rem;
  border-radius: $radius;
  &:focus {
    outline: none;
  }
  .cardContent {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      // padding-left: 1rem;
      color: $primary;
    }
    .hasImage {
      display: flex;
      height: 7rem;
      img:first-child {
        width: 6rem;
        object-fit: contain;
      }
      h4 {
        align-self: center;
      }
    }

    .cardInfo {
      margin: 1.5rem 0 0 0;
      .infoContent {
        display: flex;
        // position: absolute;
        // bottom: 0;
        width: 75%;
        margin-top: 1rem;
        .icon {
          width: 28px;
          height: 28px;
          margin-right: 1rem;
          object-fit: contain;
          &.iconWebsite {
            width: 24px;
            height: 24px;
            margin-right: 1rem;
            object-fit: contain;
          }
        }

        p,
        a {
          margin-bottom: 0;
          color: gray;
        }
      }
    }
  }
}

@media only screen and (max-width: $mobile-sm) {
  .card {
    .cardContent {
      .cardInfo {
        margin: 2rem 0;
        .infoContent {
          width: 100%;
        }
      }
    }
  }
}
</style>
